/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Validation_Invalidnumber1Inputs */

const en_common_validation_invalidnumber1 = /** @type {(inputs: Common_Validation_Invalidnumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid number`)
};

const ja_common_validation_invalidnumber1 = /** @type {(inputs: Common_Validation_Invalidnumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効な数値を入力してください`)
};

/**
* | output |
* | --- |
* | "Please enter a valid number" |
*
* @param {Common_Validation_Invalidnumber1Inputs} inputs
* @param {{ locale?: "en" | "ja" }} options
* @returns {LocalizedString}
*/
const common_validation_invalidnumber1 = /** @type {((inputs?: Common_Validation_Invalidnumber1Inputs, options?: { locale?: "en" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Validation_Invalidnumber1Inputs, { locale?: "en" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_validation_invalidnumber1(inputs)
	return ja_common_validation_invalidnumber1(inputs)
});
export { common_validation_invalidnumber1 as "common_validation_invalidNumber" }